import { useQuery } from "@tanstack/react-query";
import { getScopeOptions, ScopeOptionsQuery } from "../api/rolesPermissionsApi";

export const SCOPE_OPTIONS_KEY = "rbac-scope-options";

// GET /api/v2/rbac/scopes (§3, amended 2026-07-11). Server-side search + cascade breadcrumb.
// The catalogue is deliberately NOT filtered by the granter's C13 ceiling — the ceiling clamps at
// write time server-side — so the UI must not hide options client-side either.
export const useScopeOptions = (query: ScopeOptionsQuery = {}, enabled = true) => {
	const { data, isLoading, error } = useQuery({
		queryKey: [SCOPE_OPTIONS_KEY, query],
		queryFn: () => getScopeOptions(query),
		enabled,
	});

	return { scopeOptions: data ?? [], isLoading, error };
};
